module.exports = __webpack_public_path__ + "img/avatar_6.d8f5fb94.jpg";